import React, { ChangeEventHandler } from "react";

import ErrorFormMessage from "../ErrorFormMessage";

type PropsType = {
  name: string;
  label?: string;
  id?: string;
  placeholder?: string;
  customClasses?: string;
  value?: string;
  required?: boolean;
  readonly?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  error?: string | boolean;
  rows?: number;
};

export default function Textarea({
  id,
  name,
  label,
  placeholder,
  required = false,
  readonly = false,
  onChange,
  customClasses = "",
  value,
  error,
  rows = 4,
}: PropsType) {
  let errorClasses = "";
  if (error) {
    errorClasses = "border-red-500 text-red-500";
  }

  return (
    <div
      className={`flex w-full flex-col gap-1 rounded-[4px] border-[1px] border-[#DEDDDB] bg-white px-3 py-3 leading-[18px] ${customClasses} ${errorClasses}`}
    >
      <label
        htmlFor={name}
        className={`font-barlowregular text-[12px] text-[#7F7F7F] ${errorClasses}`}
      >
        {label}
      </label>
      <textarea
        id={id}
        name={name}
        onChange={onChange}
        className="resize-none bg-white leading-[126%] placeholder:text-[#736F62] read-only:bg-[#f6f6f6] focus:outline-none"
        placeholder={placeholder}
        value={value !== null ? value : ""}
        required={required}
        readOnly={readonly}
        rows={rows}
      />
      {error ? <ErrorFormMessage message={error} /> : null}
    </div>
  );
}
